import api from "./api";

const analyticsService = {
  // Get dashboard overview data
  getDashboard: async () => {
    try {
      const response = await api.get("/analytics/dashboard");
      return response.data;
    } catch (error) {
      console.error("Error fetching dashboard analytics:", error);
      // Return mock data as fallback
      return getMockDashboardData();
    }
  },

  // Get cost analytics
  getCost: async () => {
    try {
      const response = await api.get("/analytics/cost");
      return response.data;
    } catch (error) {
      console.error("Error fetching cost analytics:", error);
      // Return mock data as fallback
      return getMockCostData();
    }
  },

  // Get conversation analytics
  getConversations: async () => {
    try {
      const response = await api.get("/analytics/conversations");
      return response.data;
    } catch (error) {
      console.error("Error fetching conversation analytics:", error);
      // Return mock data as fallback
      return getMockConversationData();
    }
  },

  // Get daily analytics
  getDaily: async () => {
    try {
      const response = await api.get("/analytics/daily");
      return response.data;
    } catch (error) {
      console.error("Error fetching daily analytics:", error);
      // Return mock data as fallback
      return getMockDailyData();
    }
  },
};

// Mock data fallbacks
const getMockDashboardData = () => ({
  overview: {
    total_chats: 245,
    escalated_chats: 18,
    automation_rate: 92.7,
    total_cost: 12.45,
    media_processing_cost: 3.67,
    total_media_messages: 89,
    avg_cost_per_chat: 0.051,
  },
  cost_breakdown: [
    {
      provider: "groq",
      cost_type: "ai_processing",
      total_cost: 8.23,
      message_count: 156,
      avg_cost_per_message: 0.053,
    },
  ],
  media_stats: {
    total_media_messages: 89,
    audio_messages: 23,
    image_messages: 45,
    video_messages: 12,
    document_messages: 9,
    total_processing_cost: 3.67,
    avg_cost_per_media: 0.041,
  },
  conversation_stats: {
    total_conversations: 245,
    active_conversations: 12,
    escalated_conversations: 18,
    resolved_conversations: 215,
    avg_messages_per_conversation: 4.2,
    avg_resolution_time: "00:15:30",
  },
  daily_trend: [
    {
      date: "2024-01-15",
      total_chats: 23,
      escalated_chats: 2,
      automation_rate: 91.3,
      total_cost: 0.89,
      media_processing_cost: 0.23,
      total_media_messages: 8,
    },
    {
      date: "2024-01-16",
      total_chats: 28,
      escalated_chats: 3,
      automation_rate: 89.3,
      total_cost: 1.12,
      media_processing_cost: 0.34,
      total_media_messages: 11,
    },
    {
      date: "2024-01-17",
      total_chats: 32,
      escalated_chats: 2,
      automation_rate: 93.8,
      total_cost: 1.45,
      media_processing_cost: 0.28,
      total_media_messages: 9,
    },
    {
      date: "2024-01-18",
      total_chats: 19,
      escalated_chats: 1,
      automation_rate: 94.7,
      total_cost: 0.78,
      media_processing_cost: 0.19,
      total_media_messages: 6,
    },
    {
      date: "2024-01-19",
      total_chats: 35,
      escalated_chats: 4,
      automation_rate: 88.6,
      total_cost: 1.67,
      media_processing_cost: 0.42,
      total_media_messages: 14,
    },
    {
      date: "2024-01-20",
      total_chats: 41,
      escalated_chats: 3,
      automation_rate: 92.7,
      total_cost: 1.89,
      media_processing_cost: 0.35,
      total_media_messages: 12,
    },
    {
      date: "2024-01-21",
      total_chats: 26,
      escalated_chats: 2,
      automation_rate: 92.3,
      total_cost: 1.08,
      media_processing_cost: 0.25,
      total_media_messages: 8,
    },
  ],
});

const getMockCostData = () => ({
  period: "month",
  total_cost: 45.67,
  by_provider: [
    {
      provider: "groq",
      cost_type: "ai_processing",
      total_cost: 8.23,
      message_count: 156,
      avg_cost_per_message: 0.053,
    },
    {
      provider: "openai",
      cost_type: "ai_processing",
      total_cost: 15.44,
      message_count: 89,
      avg_cost_per_message: 0.173,
    },
    {
      provider: "azure",
      cost_type: "media_processing",
      total_cost: 22.0,
      message_count: 234,
      avg_cost_per_message: 0.094,
    },
  ],
  by_date: [
    {
      date: "2024-01-15",
      total_cost: 2.34,
      ai_processing_cost: 1.89,
      media_processing_cost: 0.45,
    },
    {
      date: "2024-01-16",
      total_cost: 3.12,
      ai_processing_cost: 2.34,
      media_processing_cost: 0.78,
    },
    {
      date: "2024-01-17",
      total_cost: 2.87,
      ai_processing_cost: 2.11,
      media_processing_cost: 0.76,
    },
    {
      date: "2024-01-18",
      total_cost: 1.95,
      ai_processing_cost: 1.45,
      media_processing_cost: 0.5,
    },
    {
      date: "2024-01-19",
      total_cost: 4.23,
      ai_processing_cost: 3.12,
      media_processing_cost: 1.11,
    },
    {
      date: "2024-01-20",
      total_cost: 3.67,
      ai_processing_cost: 2.78,
      media_processing_cost: 0.89,
    },
    {
      date: "2024-01-21",
      total_cost: 2.45,
      ai_processing_cost: 1.87,
      media_processing_cost: 0.58,
    },
  ],
});

const getMockConversationData = () => ({
  period: "month",
  overview: {
    total_conversations: 245,
    active_conversations: 12,
    escalated_conversations: 18,
    resolved_conversations: 215,
    avg_messages_per_conversation: 4.2,
    avg_resolution_time: "00:15:30",
  },
  escalation_reasons: [
    {
      escalation_reason: "Complex technical issue",
      count: 5,
      percentage: 27.8,
    },
    {
      escalation_reason: "Payment inquiry",
      count: 4,
      percentage: 22.2,
    },
    {
      escalation_reason: "Product complaint",
      count: 3,
      percentage: 16.7,
    },
    {
      escalation_reason: "Billing dispute",
      count: 3,
      percentage: 16.7,
    },
    {
      escalation_reason: "Account access",
      count: 2,
      percentage: 11.1,
    },
    {
      escalation_reason: "Other",
      count: 1,
      percentage: 5.6,
    },
  ],
  resolution_times: {
    avg_resolution_time: "00:15:30",
    median_resolution_time: "00:12:45",
    percentile_90: "00:35:20",
  },
});

const getMockDailyData = () => ({
  days: 30,
  trend: [
    {
      date: "2024-01-15",
      total_chats: 23,
      escalated_chats: 2,
      automation_rate: 91.3,
      total_cost: 0.89,
      media_processing_cost: 0.23,
      total_media_messages: 8,
    },
    {
      date: "2024-01-16",
      total_chats: 28,
      escalated_chats: 3,
      automation_rate: 89.3,
      total_cost: 1.12,
      media_processing_cost: 0.34,
      total_media_messages: 11,
    },
    {
      date: "2024-01-17",
      total_chats: 32,
      escalated_chats: 2,
      automation_rate: 93.8,
      total_cost: 1.45,
      media_processing_cost: 0.28,
      total_media_messages: 9,
    },
    {
      date: "2024-01-18",
      total_chats: 19,
      escalated_chats: 1,
      automation_rate: 94.7,
      total_cost: 0.78,
      media_processing_cost: 0.19,
      total_media_messages: 6,
    },
    {
      date: "2024-01-19",
      total_chats: 35,
      escalated_chats: 4,
      automation_rate: 88.6,
      total_cost: 1.67,
      media_processing_cost: 0.42,
      total_media_messages: 14,
    },
    {
      date: "2024-01-20",
      total_chats: 41,
      escalated_chats: 3,
      automation_rate: 92.7,
      total_cost: 1.89,
      media_processing_cost: 0.35,
      total_media_messages: 12,
    },
    {
      date: "2024-01-21",
      total_chats: 26,
      escalated_chats: 2,
      automation_rate: 92.3,
      total_cost: 1.08,
      media_processing_cost: 0.25,
      total_media_messages: 8,
    },
  ],
});

export default analyticsService;
